import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "test-scenarios row text-center d-flex justify-content-center" }
const _hoisted_4 = { class: "col-xl-4" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "col-xl-4 offsetxl-1" }
const _hoisted_7 = { class: "icon mx-auto" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "col-xl-4" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "test-scenarios row text-center d-flex justify-content-center" }
const _hoisted_12 = { class: "col-xl-4" }
const _hoisted_13 = { class: "col-xl-4" }
const _hoisted_14 = { class: "icon mx-auto" }
const _hoisted_15 = { class: "col-xl-4" }
const _hoisted_16 = { class: "icon mx-auto" }
const _hoisted_17 = { class: "test-scenarios row text-center d-flex justify-content-center" }
const _hoisted_18 = {
  key: 0,
  class: "col-xl-4"
}
const _hoisted_19 = {
  key: 1,
  class: "col-xl-4"
}
const _hoisted_20 = {
  key: 2,
  class: "col-xl-4"
}
const _hoisted_21 = { class: "list-unstyled text-muted small mb-5" }
const _hoisted_22 = { key: 0 }

import { computed } from "vue";
import { FinishInfoResponse } from '@/guiide/ts/response/finishInfoResponse';
import { Retiree } from "@/guiide/ts/retiree";
import { formatter } from "@/shared/ts/formatter";
import { retireeDescriber } from "@/guiide/ts/retireeDescriber";
import Constants from "@/guiide/ts/constants";
import SubSection from '../common/SubSection.vue';
import WhatYouHave from "@/guiide/components/finish/WhatYouHave.vue"
import CompositeIcon from "@/guiide/components/common/CompositeIcon.vue";

type WhatYouWantInfo = { retirementDate: string, incomeDesc: string, inflationDesc: string };

type AssumptionsInfo = {
    retirementDate: string, taxFreeChoiceText: string, giPercentAlloc: string, giRemainingText: string, giSubscriber: boolean,
    giAnnualInc: string, returnOnPensions: string, returnOnSavings: string, protectedPot: string, showProtectPotText: boolean,
    showPensionContribText: boolean, monthlyPensionContribTotal: string, contribIncreaseText: string
};


export default /*@__PURE__*/_defineComponent({
  __name: 'WhatsInYourDesign',
  props: {
    retiree: {
        type: Object as () => Retiree | null,
        default: () => null,
    },
    finishInfo: {
        type: Object as () => FinishInfoResponse,
        default: () => new FinishInfoResponse(false, 0, []),
    },
},
  setup(__props) {

const props = __props;

const whatYouWantInfo = computed<WhatYouWantInfo>(() => {
    const retiree = props.retiree;
    return retiree != null
        ? {
            retirementDate: formatter.monthAndYearDate(new Date(retiree.retirementDate)),
            incomeDesc: retireeDescriber.incomeStatement(),
            inflationDesc: retireeDescriber.inflationStatement()
        }
        : { retirementDate: '', incomeDesc: '', inflationDesc: '' };
});

const model = computed<AssumptionsInfo>(() => {
    const retiree = props.retiree;

    if (retiree == null) {
        return {
            retirementDate: '', taxFreeChoiceText: '', giSubscriber: false, giPercentAlloc: '', giRemainingText: '', giAnnualInc: '',
            returnOnPensions: '', returnOnSavings: '', protectedPot: '', showProtectPotText: false, showPensionContribText: false,
            monthlyPensionContribTotal: '', contribIncreaseText: ''
        };
    }

    const monthlyContributionAmount:number = props.retiree?.pensionPots.pots.reduce((accumulator, value) => accumulator += value.monthlyContribution, 0) ?? 0;

    const contribIncreaseText = retiree.pensionPots.pots.some(p => p.willTheseIncreaseIfSalaryIncreases)
        ? " and increase these contributions as your salary goes up"
        : "";

    return {
            retirementDate: formatter.monthAndYearDate(new Date(retiree.retirementDate)),
            taxFreeChoiceText: getTaxFreeChoiceText(retiree.requirements.takingTaxFreeAsLumpSum),
            giSubscriber: retiree.guaranteedIncome.subscribed,
            giPercentAlloc: retiree.guaranteedIncome.allocation.toString(),
            giRemainingText: retiree.requirements.takingTaxFreeAsLumpSum ? 'remaining ' : '',
            giAnnualInc: formatter.formatCurrency(retiree.guaranteedIncome.annualIncome),
            returnOnPensions: retiree.returnOnPensions.toString(),
            returnOnSavings: retiree.returnOnSavings.toString(),
            protectedPot: formatter.formatCurrency(retiree.protectedPot),
            showProtectPotText: retiree.protectedPot > 0,
            showPensionContribText: monthlyContributionAmount > 0,
            monthlyPensionContribTotal: formatter.formatCurrency(monthlyContributionAmount),
            contribIncreaseText: contribIncreaseText
        }
});

function getTaxFreeChoiceText(asLumpSum: boolean): string {
    const taxFreeCashLimit = formatter.formatCurrency(Constants.TaxFreeCashLimit);
    return asLumpSum
        ? `You've chosen to take 25% of your pension pots (up to a maximum of ${taxFreeCashLimit}) as a tax free cash lump sum immediately*.`
        : "You've chosen not to take the 25% tax free lump sum immediately from your pension pots. We've used this in this design and assumed 25% of the income you take from your pension pots will not be subject to tax.";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SubSection, {
        title: "What you want from your plan",
        showHelp: false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "icon mx-auto" }, [
                _createElementVNode("i", { class: "bi bi-calendar-heart" })
              ], -1)),
              _createElementVNode("p", _hoisted_5, [
                _cache[0] || (_cache[0] = _createTextVNode(" You will retire in ")),
                _createElementVNode("strong", null, _toDisplayString(model.value.retirementDate), 1),
                _cache[1] || (_cache[1] = _createTextVNode(" and draw down your savings and pension pots from that date. "))
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(CompositeIcon, { icons: [ { icon: 'bi-circle', size: '3.5rem' }, { icon: 'bi-currency-pound', size: '2.2rem', top: '0.95rem', left: '0.63rem' } ] })
              ]),
              _createElementVNode("p", {
                innerHTML: whatYouWantInfo.value.incomeDesc
              }, null, 8, _hoisted_8)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "icon mx-auto" }, [
                _createElementVNode("i", { class: "bi bi-percent" })
              ], -1)),
              (whatYouWantInfo.value.inflationDesc != '')
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(whatYouWantInfo.value.inflationDesc), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "icon mx-auto" }, [
                _createElementVNode("i", { class: "bi bi-cash mb-4" })
              ], -1)),
              _createElementVNode("p", null, _toDisplayString(model.value.taxFreeChoiceText), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(CompositeIcon, { icons: [{ icon: 'bi-piggy-bank', size: '3.5rem' }, { icon: 'bi-arrow-up-right', size: '1.7rem', top: '0.8rem', left: '3.5rem' }] })
              ]),
              _createElementVNode("p", null, [
                _cache[5] || (_cache[5] = _createTextVNode("You have used an estimated total return, after charges, of ")),
                _createElementVNode("strong", null, _toDisplayString(model.value.returnOnPensions) + "%", 1),
                _cache[6] || (_cache[6] = _createTextVNode(" a year on your pension pots."))
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(CompositeIcon, { icons: [{ icon: 'bi-bank', size: '3.5rem' }, { icon: 'bi-arrow-up-right', size: '1.7rem', top: '0.8rem', left: '3.5rem' }] })
              ]),
              _createElementVNode("p", null, [
                _cache[7] || (_cache[7] = _createTextVNode("You have used an estimated total return, after charges, of ")),
                _createElementVNode("strong", null, _toDisplayString(model.value.returnOnSavings) + "%", 1),
                _cache[8] || (_cache[8] = _createTextVNode(" a year on your savings pots."))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            (model.value.showPensionContribText)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "icon mx-auto" }, [
                    _createElementVNode("i", { class: "bi bi-credit-card mb-4" })
                  ], -1)),
                  _createElementVNode("p", null, [
                    _cache[9] || (_cache[9] = _createTextVNode(" You will make total monthly contributions of ")),
                    _createElementVNode("strong", null, _toDisplayString(model.value.monthlyPensionContribTotal), 1),
                    _createTextVNode(" per month to your pension pots" + _toDisplayString(model.value.contribIncreaseText) + ". ", 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (model.value.showProtectPotText)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "icon mx-auto" }, [
                    _createElementVNode("i", { class: "bi bi-shield-lock" })
                  ], -1)),
                  _createElementVNode("p", null, [
                    _cache[11] || (_cache[11] = _createTextVNode(" You have chosen to protect ")),
                    _createElementVNode("strong", null, _toDisplayString(model.value.protectedPot), 1),
                    _cache[12] || (_cache[12] = _createTextVNode(" of your pensions pots throughout your retirement and not reduce your pension pots below this level. "))
                  ])
                ]))
              : _createCommentVNode("", true),
            (model.value.giSubscriber)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _cache[19] || (_cache[19] = _createElementVNode("div", { class: "icon mx-auto" }, [
                    _createElementVNode("i", { class: "bi bi-bag mb-4" })
                  ], -1)),
                  _createElementVNode("p", null, [
                    _cache[14] || (_cache[14] = _createTextVNode(" You have chosen to use ")),
                    _createElementVNode("strong", null, _toDisplayString(model.value.giPercentAlloc) + "%", 1),
                    _cache[15] || (_cache[15] = _createTextVNode(" of your ")),
                    _createElementVNode("strong", null, _toDisplayString(model.value.giRemainingText), 1),
                    _cache[16] || (_cache[16] = _createTextVNode(" pension pots to model a potential purchase of a lifetime guaranteed income")),
                    _cache[17] || (_cache[17] = _createElementVNode("sup", null, "**", -1)),
                    _cache[18] || (_cache[18] = _createTextVNode(". "))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("ul", _hoisted_21, [
            _cache[21] || (_cache[21] = _createElementVNode("li", { class: "mb-3" }, [
              _createElementVNode("sup", null, "*"),
              _createTextVNode(" We've assumed you'll spend this and it has not been used in this design.")
            ], -1)),
            (model.value.giSubscriber)
              ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                  _cache[20] || (_cache[20] = _createElementVNode("sup", null, "**", -1)),
                  _createTextVNode(" Based on illustrative rates the annual guaranteed income purchased may be " + _toDisplayString(model.value.giAnnualInc) + ". This is an illustration only and the actual amount you would receive could be higher or lower. Actual rates will depend on your age when you apply, plus they will be personalised to you, so other factors such as your health, lifestyle and where you live will determine the final rate. ", 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(WhatYouHave, { retiree: __props.retiree }, null, 8, ["retiree"])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})